<template>
  <div class="Manage-process-main" :class="{ 'Manage-process-main-mobile': isMobile }">
    <div class="center">
      <Base-title title="整合式创新的管理流程"></Base-title>
      <ManageProcessContent></ManageProcessContent>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
export default {
  // 管理体系
  name: "ManageProcess",
};
</script>
<style lang="scss" scoped>
.Manage-process-main {
  background: #f6faff;
  .center {
    width: calc($multiple * 1040px);
    margin: auto;
    position: relative;
    display: flex;
    align-items: center;
    padding-top: calc($multiple * 78px);
    height: calc($multiple * 723px);
    flex-direction: column;
  }
}
.Manage-process-main-mobile {
  .center {
    width: auto;
    padding-top: 1.89rem;
    height: 45rem;
  }
}
</style>
